/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTheme, Autocomplete, TextField } from '@mui/material'
import { ItemCollectionTypeQuery } from '@kistill/client/data-access'

interface CollectionTypeChipProps {
  data: ItemCollectionTypeQuery | undefined
}

export function CollectionTypeChip({ data }: CollectionTypeChipProps) {
  const theme = useTheme()

  const options = data?.getCollectionTypes?.map((option: any) => {
    const firstLetter = option.name[0].toUpperCase()
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    }
  })

  return (
    <Autocomplete
      multiple
      size='small'
      id='itemcollection'
      sx={{
        backgroundColor: theme.palette.background.paper,
      }}
      renderInput={(params) => <TextField {...params} label='Tegund' />}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(customers, options) =>
        customers?.name === options.name
      }
      options={[
        ...(options
          ?.map((x: any) => ({
            name: x.name,
            firstLetter: x.firstLetter,
          }))
          .sort(
            (a: any, b: any) => -b.firstLetter.localeCompare(a.firstLetter),
          ) ?? []),
      ]}
    />
  )
}

export default CollectionTypeChip
